export default __webpack_public_path__ + "static/media/regiom-logo-black.2da16c07.svg";